import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const documentDataClassName = DataClassName.DOCUMENT
const documentEndpoint = PisaDataClassEndpoint.DOCUMENT

export function pisaDocumentDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(documentDataClassName, {
    title: documentDataClassName,
    restApi: createPisaRestApiConfig(documentEndpoint),
    attributes,
  })
}
